import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { Column } from 'react-table';
import Table from '../../components/Table';
import {
  Button,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  Popover,
  Select,
  SvgIcon,
  TextField,
  Typography,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
} from '@material-ui/pickers';
import * as StatsAPI from '../../api/statistics/statistics';
import * as StatsModels from '../../api/statistics/models';
import * as ShortAPI from '../../api/short/index';
import * as ShortModels from '../../api/short/models';
import { AccessTime } from '@material-ui/icons';
import moment from 'moment';
import 'moment/locale/da';
import daLocale from 'date-fns/locale/da';
import NoDataDialog from '../../components/dialogs/ErrorDialog';
import APIRequest from '../../components/helpers/APIRequest';
import * as CSV from '../../utils/exportcsv';
import LoadingSymbols from '../../utils/loadingSymbol';
import * as mobilbase from '../../api/mobilbase';
import AlignedCell from '../../components/layout//AlignedCell';
import AlignedHeader from '../../components/layout/AlignedHeader';
import '../../index.css'

moment.locale('da');

const useStyles = makeStyles((theme) => ({
  paper: {
    [theme.breakpoints.up('sm')]: {
      padding: '0',
    },
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  buts: {
    width: '100%',
    height: '100%',
  },
  autoForm: {
    width: '100%',
    height: '100%',
    marginTop: '0.5rem',
  },
  grid: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  textHelp: {
    marginBottom: '1rem',
  },
  margTop: {
    marginTop: theme.spacing(2),
  },
}));

const TransactionStatistics: FC = () => {
  const classes = useStyles();

  const [currentLocation, setCurrentLocation] = useState(-1);
  const [locations, setLocations] = useState<ShortModels.Location[]>([]);
  const [isPendingLocations, setIsPendingLocations] = useState(false);
  const [runLocations, setRunLocations] = useState(true);

  const [devices, setDevices] = useState<StatsModels.DeviceListResponse>(
    new StatsModels.DeviceListResponse()
  );
  const [isPendingDevices, setIsPendingDevices] = useState(false);
  const [runGetDevices, setRunGetDevices] = useState(false);

  const [transactionReportData, setTransactionReportData] =
    useState<StatsModels.TransactionReportResponse>({
      version: '',
      id: '',
      result: { data: [], sums: [], rates:[] },
    });
  const [fillteredTransactionReportData, setFillteredTransactionReportData] =
    useState<StatsModels.TransactionReportResponse>({
      version: '',
      id: '',
      result: { data: [], sums: [], rates:[] },
    });
  const [isPending, setIsPending] = useState(false);
  const [run, setRun] = useState(false);
  const [showError, setShowError] = useState(false);
  const [fromDate, setFromDate] = useState<Date | null>(new Date());
  const [toDate, setToDate] = useState<Date | null>(new Date());
  const [fromTime, setFromTime] = useState<Date | null>(
    new Date(0, 0, 0, 0, 0, 0, 0)
  );
  const [toTime, setToTime] = useState<Date | null>(
    new Date(0, 0, 0, 23, 59, 0, 0)
  );
  const [timeRange, setTimeRange] = useState(false);
  const [fetchData, setFetchData] = useState(false);
  const [downloadData, setDownloadData] = useState(false);

  const [pendingLoadingPicture, setPendingLoadingPicture] = useState(false);
  const [selectedDevices, setSelectedDevices] = useState<
    StatsModels.DeviceData[]
  >([]);

  const labelLocationRef = useRef(null);
  // @ts-ignore: Object is possibly 'null'
  /*const labelLocationWidth =
    labelLocationRef !== null && labelLocationRef.current !== null
      ? labelLocationRef.current.clientWidth
      : 0;*/

  var keyList = [''];

  useEffect(() => {
    function handleKeyDown(event: any) {
      const keyname = event.key;
      keyList.push(keyname);

      if (event.shiftKey && keyList.includes('S') && keyList.includes('E')) {
        setDownloadData(true);
      }
      if (event.shiftKey && keyList.includes('S') && keyList.includes('H')) {
        setFetchData(true);
      }
    }
    document.addEventListener('keydown', handleKeyDown);

    return function cleanUP() {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });

  useEffect(() => {
    function handleKeyUp(event: any) {
      keyList = [''];
      setDownloadData(false);
      setFetchData(false);
    }
    document.addEventListener('keyup', handleKeyUp);

    return function cleanUP() {
      document.removeEventListener('keyup', handleKeyUp);
    };
  });

  useEffect(() => {
    if (downloadData) {
      downloadCSV();
    }
  }, [downloadData]);

  useEffect(() => {
    if (fetchData) {
      return setRun(true);
    }
  }, [fetchData]);

  useEffect(() => {
    if (locations.length > 0 && currentLocation === -1) {
      setCurrentLocation(locations[0].id);
      setRunGetDevices(true);
    }
  }, [locations, currentLocation]);

  useEffect(() => {
    if (currentLocation > 0) {
      setRunGetDevices(true);
    }
  }, [currentLocation]);

  useEffect(() => {
    // show data fetching loading picture
    if (!isPending) {
      setPendingLoadingPicture(false);
    } else {
      setPendingLoadingPicture(true);
    }
  }, [isPending]);

  // function customCellStyle <T extends object>(columns: Column<T>[], index: number, value: any) {
  //   return {
  //     background:"rgba(255, 0, 0, 0.3)",
  //     textAlign: (columns[index].accessor?.toString() === "parkingTime" ) ? 'right' : "left"
  //   }
  // };
  const columnsSums: Column<StatsModels.TransactionReportData>[] =
    React.useMemo(
      () => [
        { Header: 'Betalingsmetode', id: '0', accessor: 'cardFirm' },
        {
          Header:()=><AlignedHeader value='Beløb [DKK]' justify='flex-end' alignT='right' width='150px' />,
          id: '1',
          accessor: 'amount',
          sortType: compareNumericString,
          Cell: ({ value }: { value: string }) => <AlignedCell value={value} width='150px' />,
        },
        { Header:()=><AlignedHeader value='Antal' justify='flex-end' alignT='right' width='150px'/>, 
          id: '2', 
          accessor: 'cardCount',
          Cell: ({ value }: { value: string }) => <AlignedCell value={value}  width='150px'/> 
        },
        { 
          Header:()=><AlignedHeader value='Gebyr [DKK]' justify='flex-end' alignT='right' width='150px'/>, 
          id: '3', 
          accessor: 'fee', 
          Cell: ({ value }: { value: string }) => <AlignedCell value={value}  width='150px'/>
        },
        { Header:()=><AlignedHeader value='Parkeringstid [min]' justify='flex-end' alignT='right' width='150px'/>, 
          id: '4', 
          accessor: 'parkingTime', 
          Cell: ({ value }: { value: string }) => <AlignedCell value={value}  width='150px'/>
        },
      ],
      []
    );

    const columnsParkType: Column<StatsModels.TransactionReportData>[] =
    React.useMemo(
      () => [
        { Header: 'Parkering Type', id: '0', accessor: 'rateType',},
        { 
          Header:()=><AlignedHeader value= 'Antal' justify='flex-end' alignT='right' width='150px'/>, 
          id: '1', 
          accessor: 'cardCount',
          Cell: ({ value }: { value: string }) => <AlignedCell value={value}  width='150px'/>
        },
        { 
          Header:()=><AlignedHeader value= 'Parkeringstid [min]' justify='flex-end' alignT='right' width='150px'/>, 
          id: '3', 
          accessor: 'parkingTime',
          Cell: ({ value }: { value: string }) => <AlignedCell value={value} width='150px' />
        },
      ],
      []
    );

  const columnsTransactionReport: Column<StatsModels.TransactionReportData>[] =
    React.useMemo(
      () => [
        { Header: 'Automat', id: '0', accessor: 'deviceName' },
        { Header: 'Betalingsmetode', id: '1', accessor: 'cardFirm' },
        { Header: 'Betalingsref.', id: '2', accessor: 'card' },
        {
          Header: ()=><AlignedHeader value= 'Beløb [DKK]' justify='flex-end' alignT='right' width='75px'/>,
          id: '3',
          accessor: 'amount',
          sortType: compareNumericString,
          Cell: ({ value }: { value: string }) => <AlignedCell value={value} width='75px'/>
        },
        { Header: ()=><AlignedHeader value= 'Gebyr [DKK]' justify='flex-end' alignT='right' width='75px'/>,
          id: '4', 
          accessor: 'fee', 
          Cell: ({ value }: { value: string }) => <AlignedCell value={value}  width='75px'/> 
        },
        {
          Header: 'Betalingstidspunkt',
          id: '5',
          accessor: 'paymentTimeString',
          sortType: compareDateString,
        },
        {
          Header: ()=><AlignedHeader value= 'Parkeringstid [min]' justify='flex-end' alignT='right' width='100px'/>,
          id: '6',
          accessor: 'parkingTime',
          sortType: compareNumericString,
          Cell: ({ value }: { value: string }) => <AlignedCell value={value} width='100px' />
        },
        { Header: 'Nummerplade', id: '7', accessor: 'plate' },
        { Header: 'Start', id: '8', accessor: 'start' },
        { Header: 'Slut', id: '9', accessor: 'end' },
        { Header: 'Type', id: '10', accessor: 'rateType' },
        { Header: 'Rabatkode', id: '11', accessor: 'discountCode' },
        { Header: 'Rabattype', id: '12', accessor: 'discountType' },
      ],
      []
    );

  const RequestData = () => {
    const fixDate = (
      date: Date | null,
      time: Date | null,
      startOfDay: boolean
    ) => {
      // We have to send the date with a UTC timezone, or the server will get the value wrong
      var d1 = date ? date : new Date();
      var t1 = time ? time : new Date();
      var d = new Date(
        Date.UTC(
          d1.getFullYear(),
          d1.getMonth(),
          d1.getDate(),
          t1.getHours(),
          t1.getMinutes(),
          0,
          0
        )
      );

      return d;
    };

    const param = (): StatsModels.Params => {
      // Choose all devices if none are chosen
      var meters =
        selectedDevices.length < 1 ? devices.result : selectedDevices;
      return {
        location: currentLocation,
        body: {
          Start: fixDate(fromDate, fromTime, true),
          End: fixDate(toDate, toTime, false),
          Meters: meters.map((d) => d.id),
        },
      };
    };

    return (
      <APIRequest<StatsModels.TransactionReportResponse>
        run={run}
        setRun={setRun}
        pending={isPending}
        setIsPending={setIsPending}
        req={() => StatsAPI.getTransactionReport(0, param())}
        setData={setTransactionReportData}
        setShowError={setShowError}
      />
    );
  };

  function compareNumericString(rowA: any, rowB: any, id: any, desc: any) {
    let a = parseFloat(rowA.values[id].replace('.', ''));
    let b = parseFloat(rowB.values[id].replace('.', ''));

    if (rowA.values[0] === 'Total' || rowA.values[1] === 'Total') {
      // find total row, and put it last or first
      a = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    }
    if (rowB.values[0] === 'Total' || rowB.values[1] === 'Total') {
      b = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    }
    if (a > b) return 1;
    if (a < b) return -1;
    return 0;
  }

  function compareDateString(rowA: any, rowB: any) {
    let a = rowA.original.paymentTime;
    let b = rowB.original.paymentTime;

    if (
      rowA.original.cardFirm === 'Total' ||
      rowA.original.cardFirm === 'Total'
    ) {
      // put total at top when Decending && end when accending
      return (a = Number.NEGATIVE_INFINITY);
    }
    if (
      rowB.original.cardFirm === 'Total' ||
      rowB.original.cardFirm === 'Total'
    ) {
      // put total at top when Decending && end when accending
      return (b = Number.NEGATIVE_INFINITY);
    }

    if (a > b) return 1;
    if (a < b) return -1;
    return 0;
  }

  const RequestLocationsData = () => {
    return (
      <APIRequest<ShortModels.Location[]>
        run={runLocations}
        setRun={setRunLocations}
        pending={isPendingLocations}
        setIsPending={setIsPendingLocations}
        req={ShortAPI.getLocations}
        setData={setLocations}
      />
    );
  };

  const RequestDevices = () => {
    return (
      <APIRequest<StatsModels.DeviceListResponse>
        run={runGetDevices}
        setRun={setRunGetDevices}
        pending={isPendingDevices}
        setIsPending={setIsPendingDevices}
        req={() => StatsAPI.getDeviceList(currentLocation)}
        setData={setDevices}
      />
    );
  };
  const setDevicesSelection = (newSelection: ShortModels.Device[] | null) => {
    if (newSelection) {
      setSelectedDevices(newSelection);
    } else {
      setSelectedDevices([]);
    }
  };
  const XlsxParam = (): StatsModels.ParamsXlsx => {
    var meters = selectedDevices.length < 1 ? devices.result : selectedDevices;
    let mett: number[] = meters.map((d) => d.id);
    const fixDate = (
      date: Date | null,
      time: Date | null,
      startOfDay: boolean
    ) => {
      // We have to send the date with a UTC timezone, or the server will get the value wrong
      var d1 = date ? date : new Date();
      var t1 = time ? time : new Date();
      var d = new Date(
        Date.UTC(
          d1.getFullYear(),
          d1.getMonth(),
          d1.getDate(),
          t1.getHours(),
          t1.getMinutes(),
          0,
          0
        )
      );

      return d;
    };
    return {
      location: currentLocation,
      body: {
        Start: fixDate(fromDate, fromTime, true),
        End: fixDate(toDate, toTime, false),
        Meters: mett,
        Columns1: columnsSums,
        Columns2: columnsParkType,
        Columns3: columnsTransactionReport,
      },
    };
  };

  const downloadCSV = async () => {

    setPendingLoadingPicture(true); // start loading symbol
    await mobilbase
//      .requestXlsx('posteringsoversigt.xlsx', 'transactions', XlsxParam())
      .requestXlsxBlop('posteringsoversigt.xlsx', 'transactions', XlsxParam())
      .then((res) => {
        setPendingLoadingPicture(false); // ends loading symbol
      })
      .catch((err) => {
        setPendingLoadingPicture(false); // end loading symbol
        setShowError(true); // if something fails, start error message
      });
  };

  function updateLocValue(val: any) {
    // the method that the currentlocation gets updated from the Autocomplete
    let updatedLocValue = val?.id;
    setSelectedDevices([]); // clears the selected devices

    if (updatedLocValue === null) {
      return false;
    } else {
      setCurrentLocation(updatedLocValue);
      return true;
    }
  }

  return (
    <Container maxWidth={false}>
      <RequestData />
      <RequestLocationsData />
      <RequestDevices />
      <div className={classes.paper}>
        <LoadingSymbols
          pendingLoadingPicture={pendingLoadingPicture}
          setPendingLoadingPicture={pendingLoadingPicture}
          open={pendingLoadingPicture}
          loadingSymbolText={'Henter data, vent venligst...'}
        />
        <Typography component="h1" variant="h5">
          Posteringsoversigt
        </Typography>
        <Container maxWidth={'lg'} className={classes.margTop}>
          {/* <div className={classes.paper}> */}
          {/* <Typography component="h4" variant="h5">Der kan kun søges på enten </Typography> */}
          <MuiPickersUtilsProvider locale={daLocale} utils={DateFnsUtils}>
            <Grid container spacing={2} alignItems="center" justify="center">
              <Grid item xs={6}>
                <FormControl variant="outlined" fullWidth margin="normal">
                  <InputLabel
                    ref={labelLocationRef}
                    shrink
                    htmlFor="transactions-location"
                  ></InputLabel>
                  <Autocomplete
                    id="id"
                    options={locations}
                    getOptionLabel={(option) => option.name}
                    defaultValue={locations[0]}
                    onChange={(event, value) => updateLocValue(value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Pladser"
                        variant="outlined"
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Autocomplete
                  className={classes.autoForm}
                  multiple
                  disableCloseOnSelect
                  filterSelectedOptions
                  value={selectedDevices}
                  options={devices.result}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        selectedDevices.length === 0
                          ? 'Automater - alle valgt'
                          : 'Automater'
                      }
                      variant="outlined"
                      fullWidth
                    />
                  )}
                  onChange={(event, newSelection) =>
                    setDevicesSelection(newSelection)
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <KeyboardDatePicker
                  fullWidth
                  disableToolbar
                  variant="inline"
                  inputVariant="outlined"
                  format="dd-MM-yyyy"
                  margin="normal"
                  id="date-picker-inline"
                  label="Fra dato"
                  value={fromDate}
                  onChange={setFromDate}
                  KeyboardButtonProps={{ 'aria-label': 'Set dato' }}
                />
              </Grid>
              <Grid item xs={6}>
                <KeyboardDatePicker
                  fullWidth
                  disableToolbar
                  variant="inline"
                  inputVariant="outlined"
                  format="dd-MM-yyyy"
                  margin="normal"
                  id="date-picker-inline"
                  label="Til dato"
                  value={toDate}
                  onChange={setToDate}
                  KeyboardButtonProps={{ 'aria-label': 'Set dato' }}
                />
              </Grid>
              <Grid item xs={6}>
                <KeyboardTimePicker
                  onClick={() => {}}
                  fullWidth
                  disableToolbar
                  variant="inline"
                  ampm={false}
                  keyboardIcon={<AccessTime />}
                  inputVariant="outlined"
                  format="HH:mm"
                  margin="normal"
                  id="time-picker-inline"
                  label="Fra tid"
                  value={fromTime}
                  onChange={setFromTime}
                  KeyboardButtonProps={{ 'aria-label': 'Set time' }}
                />
              </Grid>
              <Grid item xs={6}>
                <KeyboardTimePicker
                  onClick={() => {}}
                  fullWidth
                  disableToolbar
                  variant="inline"
                  ampm={false}
                  keyboardIcon={<AccessTime />}
                  inputVariant="outlined"
                  format="HH:mm"
                  margin="normal"
                  id="time-picker-inline"
                  label="Til tid"
                  value={toTime}
                  onChange={setToTime}
                  KeyboardButtonProps={{ 'aria-label': 'Set time' }}
                />
              </Grid>
              <Grid item xs={5}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.buts}
                  onClick={() => setRun(true)}
                >
                  Hent
                </Button>
              </Grid>
              <Grid item xs={5}>
                <Button
                  disabled={transactionReportData.result.data.length < 1}
                  variant="contained"
                  color="primary"
                  className={classes.buts}
                  onClick={downloadCSV}
                >
                  Eksportér
                </Button>
              </Grid>
            </Grid>
          </MuiPickersUtilsProvider>
          {/* </Paper> */}
          {/* </div> */}
        </Container>
        <div className={classes.paper}>
          <Typography component="h1" variant="h5">
            Opsummeringer
          </Typography>
        </div>
        <div className={classes.grid}>
          <Table<StatsModels.TransactionReportData>
            columns={columnsSums}
            data={transactionReportData.result.sums}
            initialState={{ pageSize: 150 }}
            clickEvent={() => {}}
            update={null}
            pending={false}
            text={''}
//            customCellStyle={customCellStyle} 
          />
        </div>
        {transactionReportData.result.rates.length > 0 && (
        <div className={classes.grid}>
          <div className={classes.paper}>
            <Typography component="h1" variant="h5">
              Parkerings typer
            </Typography>
          </div>
          <div className={classes.grid}>
            <Table<StatsModels.TransactionReportData>
              columns={columnsParkType}
              data={transactionReportData.result.rates}
              initialState={{ pageSize: 150 }}
              clickEvent={() => {}}
              update={null}
              pending={false}
              text={''}
//              customCellStyle={customCellStyle} 
              />
          </div>
        </div>
        )}
        <div className={classes.paper}>
          <Typography component="h1" variant="h5">
            Posteringer
          </Typography>
        </div>
        <div className={classes.grid}>
          <Table<StatsModels.TransactionReportData>
            columns={columnsTransactionReport}
            data={transactionReportData.result.data}
            initialState={{ pageSize: 150 }}
            clickEvent={() => {}}
            update={null}
            pending={false}
            text={''}
//            customCellStyle={customCellStyle} 
          />
        </div>
      </div>
      <NoDataDialog
        open={showError}
        onClose={() => {
          setShowError(false);
        }}
        title={'Intet svar'}
        text={'Noget gik galt, prøv venligst igen senere.'}
      />
    </Container>
  );
};

export default TransactionStatistics;
